var map = {
	"./Instagram.svg": 6403,
	"./RocketLaunch.svg": 1800,
	"./Twitter.svg": 1760,
	"./about.svg": 5632,
	"./arrow.svg": 9452,
	"./box1.svg": 8028,
	"./box2.svg": 4020,
	"./box3.svg": 160,
	"./box4.svg": 8224,
	"./box5.svg": 6624,
	"./calendar.svg": 1728,
	"./close.svg": 3556,
	"./cosmos.svg": 4932,
	"./discord.svg": 6828,
	"./facebook.svg": 1672,
	"./games.svg": 9528,
	"./menu.svg": 1180,
	"./metaverse.svg": 2016,
	"./profit-1.svg": 7212,
	"./profit-2.svg": 2768,
	"./profit-3.svg": 228,
	"./profit.svg": 8940,
	"./real-estate.svg": 7984,
	"./reward.svg": 8052,
	"./services-sec-home-page-.png": 1684,
	"./services-sec-home-page-02.png": 2511,
	"./services-sec-home-page-1.png": 2076,
	"./services-sec-home-page-3.png": 1024,
	"./telegram.svg": 8544,
	"./user.svg": 1720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9868;